import { COMMUNITY_TYPE } from '@space-shell/modules/communities/accessAndPrivacy/constants'
import { CHANGE_TYPE } from '@space-shell/modules/home/datahub/schemas/try/community/tryToChangeCommunityType'

export function mapToChangeTypeLabelForDatahub(
  communityType: COMMUNITY_TYPE,
  pendingType: COMMUNITY_TYPE
): CHANGE_TYPE {
  const changeTypeMap: Record<COMMUNITY_TYPE, Partial<Record<COMMUNITY_TYPE, CHANGE_TYPE>>> = {
    [COMMUNITY_TYPE.EXCLUSIVE]: {
      [COMMUNITY_TYPE.PUBLIC]: CHANGE_TYPE.EXCLUSIVA_PARA_PUBLICA,
      [COMMUNITY_TYPE.OPEN]: CHANGE_TYPE.EXCLUSIVA_PARA_ABERTA
    },
    [COMMUNITY_TYPE.PUBLIC]: {
      [COMMUNITY_TYPE.EXCLUSIVE]: CHANGE_TYPE.PUBLICA_PARA_EXCLUSIVA,
      [COMMUNITY_TYPE.OPEN]: CHANGE_TYPE.PUBLICA_PARA_ABERTA
    },
    [COMMUNITY_TYPE.OPEN]: {
      [COMMUNITY_TYPE.EXCLUSIVE]: CHANGE_TYPE.ABERTA_PARA_EXCLUSIVA,
      [COMMUNITY_TYPE.PUBLIC]: CHANGE_TYPE.ABERTA_PARA_PUBLICA
    },
    [COMMUNITY_TYPE.PAID]: {}
  }

  return changeTypeMap[communityType][pendingType] as CHANGE_TYPE
}
